import { autoUpdate, flip, offset, shift, useFloating, useHover, useInteractions, useRole } from '@floating-ui/react';
import { isDefined } from '@sgme/fp';
import { createPortal } from 'react-dom';

import { SgFormattedMessage } from '../../SgFormattedMessage';
import { useSgCurrencyPairPickerContext } from './context.tsx';
import { actions } from './reducer.ts';

export const CurrencyPairTooltipError = () => {
  const {
    state: { hasError, isTooltipOpen },
    dispatch,
    inputRef,
  } = useSgCurrencyPairPickerContext();

  // Configuration for floating-ui (error tooltip)
  const {
    refs: tooltipRefs,
    floatingStyles: tooltipStyles,
    context: tooltipContext,
  } = useFloating({
    open: isTooltipOpen,
    onOpenChange: (isOpen: boolean) => {
      dispatch(actions.errorTooltipOpeningChanged({ isOpen }));
    },
    placement: 'right',
    middleware: [offset(8), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
    elements: { reference: inputRef },
  });

  const hover = useHover(tooltipContext, {
    enabled: hasError,
  });

  const tooltipRole = useRole(tooltipContext, { role: 'tooltip' });

  const { getFloatingProps: getTooltipFloatingProps } = useInteractions([hover, tooltipRole]);

  const errorTooltip =
    hasError && isTooltipOpen ? (
      <div
        {...getTooltipFloatingProps({
          ref: tooltipRefs.setFloating,
        })}
        className="bg-danger text-white p-1 rounded"
        style={{
          ...tooltipStyles,
          zIndex: 10000, // Ensure tooltip is above everything
        }}
      >
        <div className="px-4">
          <SgFormattedMessage id="currencyPairPicker.errors.invalid" />
        </div>
      </div>
    ) : null;

  return isDefined(errorTooltip) && createPortal(errorTooltip, document.body);
};
